import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import {
  getStatus as getStatusAction,
  refreshStatus as refreshStatusAction,
  clearLocalStatus as clearLocalStatusAction
} from 'actions/status';

const useStatus = () => {
  const dispatch = useDispatch();
  
  const getStatus = useCallback(() => dispatch(getStatusAction()), [dispatch]);
  const refreshStatus = useCallback(() => dispatch(refreshStatusAction()), [dispatch]);
  const clearLocalStatus = useCallback(() => dispatch(clearLocalStatusAction()), [dispatch]);

  return {
    getStatus,
    refreshStatus,
    clearLocalStatus
  };
};

export default useStatus;

